module.exports = __webpack_public_path__ + "static/media/mission.9ad79f7c.svg";